const Spring = () => {
    return(
        <svg className='spring' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 63.06 62.98'>
            <path d='M57.24,45.35c-7.76,10.34-24.34,6.85-35,7.35,0,0-1.88.11-3.78.42,0,0,.72-.31,1.64-.62,7.46-2.59,11-3.1,15.53-5.43,8.52-4.37,17-13.88,18.73-23.76-3.25,9.5-13.11,17.68-22.1,21C26.14,46.58,15,48.79,15,48.79l-.45-.24c-7.56-3.68-7.78-20.06,6-25.34,6-2.32,11.78-1,18.29-2.59C45.76,19,53.8,13.76,57.07,7,60.74,17.83,65.14,34.83,57.24,45.35Zm.14-41.76A29.41,29.41,0,0,1,54,9.53a31.47,31.47,0,1,0-43.95,45l.69.61a2.69,2.69,0,1,1,3.78-.39,2.7,2.7,0,0,1-3.78.39l.47.41A31.45,31.45,0,0,0,62.88,33.76c.87-8-1.49-18.12-5.5-30.17'/>
        </svg>
    )
}

export default Spring